// Error carrying the HTTP status so callers can distinguish terminal failures
// (e.g. 404 — record gone, never coming back) from transient ones worth retrying.
export class ApiError extends Error {
  status: number
  constructor(method: string, path: string, status: number) {
    super(`${method} ${path} failed: ${status}`)
    this.name = "ApiError"
    this.status = status
  }
}

function csrfToken(): string | null {
  const el = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  return el?.content ?? null
}

function withCsrf(headers: HeadersInit = {}): HeadersInit {
  const token = typeof document !== "undefined" ? csrfToken() : null
  return token
    ? { ...(headers as Record<string, string>), "X-CSRF-Token": token }
    : headers
}

export async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: withCsrf({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new ApiError("POST", path, res.status)
  return (await res.json()) as T
}

export async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, {
    credentials: "same-origin",
    headers: withCsrf({ Accept: "application/json" }),
  })
  if (!res.ok) throw new ApiError("GET", path, res.status)
  return (await res.json()) as T
}
